export const version = "rlp/5.0.6";
//# sourceMappingURL=_version.js.map